/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-useless-escape */
import React, { useContext, useState } from "react";
import { connect } from "react-redux";
import cn from "classnames";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";
import DropdownWrapper from "react-dropdown-wrapper";
import GameDetails from "zweeler-game-details";
import { Modal, Button } from "react-bootstrap";
const TranslationsContext = React.createContext();
const SportsNameContext = React.createContext();

function pad(n, width, z) {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

function formatLiveInTime(t) {
  if (t > 0) {
    if (t > 86400)
      //24 hours
      return (
        Math.floor(t / 86400) +
        "d " +
        (Math.floor(t / 3600) % 24) +
        ":" +
        pad(Math.floor((t / 60) % 60), 2)
      );
    else
      return (
        (Math.floor(t / 3600) % 24) +
        ":" +
        pad(Math.floor((t / 60) % 60), 2) +
        ":" +
        pad(Math.floor(t % 60), 2)
      );
  } else {
    return "-";
  }
}

function formatCurrency(value) {
  var formatter = Intl.NumberFormat("en", {
    style: "currency",
    currency: value.currency,
  });
  return formatter.format(value.amount / 100);
}

const fetchAllGames = ({ currency }) => {
  return axios.get(`/api/v1/lobby/games/init/upcoming/${currency}`);
};

const fetchBanners = ({ currency, language }) => {
  return axios.get(`/api/v1/lobby/banners/${currency}/${language}`);
};

const bannersGradientMap = {
  0: "grad-brown",
  1: "grad-green",
  2: "grad-blue",
};

const sportsIconMap = {
  27: "i-american-football",
  25: "i-baseball",
  15: "i-basketball",
  20: "i-biathlon",
  9: "i-cyclocross",
  1: "i-cycling",
  16: "i-dakar",
  8: "i-darts",
  35: "i-entertainment",
  3: "i-formulaone",
  7: "i-football",
  10: "i-golf",
  21: "i-hand-ball",
  26: "i-ice-hockey",
  2: "i-ice-speed-skating",
  34: "i-mix-martial-arts",
  6: "i-moto-gp",
  12: "i-olympic",
  19: "i-rugby",
  33: "i-ski-jumping",
  17: "i-skiiing",
  11: "i-snooker",
  5: "i-tennis",
};

const sportsNameMap = {
  1: "Cycling",
  2: "Ice Speed Skating",
  3: "Formula 1",
  5: "Tennis",
  6: "MotoGP",
  7: "Football",
  8: "Darts",
  9: "Cyclocross",
  10: "Golf",
  11: "Snooker",
  12: "Olympics",
  15: "Basketball",
  16: "Dakar",
  17: "Skiing",
  19: "Rugby",
  20: "Biathlon",
  21: "Handball",
  23: "Cross Country",
  25: "Baseball",
  26: "Ice hockey",
  27: "American Football",
  33: "Ski Jumping",
  34: "MMA",
  35: "Entertainment",
};

// Max team is a new feature and initially has 0 as max team's value, so these conditions are needed
function isGameFull(row) {
  if (row.url) {
    if (row.allTeams > 0) {
      if (row.paidTeams < row.allTeams) {
        return false;
      } else {
        // This is for instances that max team is not set (example, paidteams = 200, and max team = 0)
        if (row.paidTeams > row.allTeams) {
          return false;
        } else {
          if (row.paidTeams == row.allTeams) {
            return true;
          }
        }
      }
    }

    return false;
  }

  return false;
}

function sportsIconFormatter(cell, row) {

  let isFull = isGameFull(row);

  return (
    <SportsIcon
      activeFilterId={false}
      sportsId={true}
      containerClass="lobby-table-icons-col"
      iconStylesClass="sports-table-icon"
      iconClass={sportsIconMap[cell]}
      title={sportsNameMap[cell]}
      id={cell}
      isFull={isFull}
    />
  );
}

function teamsFormatter(cell, row) {
  if (row.state == 2) {
    return `${row.paidTeams}/${row.allTeams}`;
  }
  return null;
}

function priceFormatter(cell, row) {
  if (!cell) return null;
  return formatCurrency(cell);
}

function prizeFormatter(cell, row) {
  if (row.prizeFinal && row.prizeFinal.amount && row.prizeFinal.amount > 0) {
    return formatCurrency(row.prizeFinal);
  } else if (!cell) {
    return null;
  }
  return formatCurrency(cell);
}

function enterFormatter(cell, row, buttonLabels) {
  if (row.url) {
    if (row.paidTeams < row.allTeams) {
      if (row.state == 2){
        return <button className="table-btn-enter" style={{ textTransform: 'uppercase' }}>{`${buttonLabels.enter} >`}</button>;
      }
      return null;
    } else {
      if (row.state == 2) {
        // only if paidTeams == teamsLimit
        if (row.allTeams > 0) {
          if (row.paidTeams == row.allTeams) {
            return <button className="table-btn-full" style={{ textTransform: 'uppercase' }}>{buttonLabels.full}</button>;
          }
          return null;
        }
        return null;
      } 
      return null;
    }
  }
  return null;
}

function maxPossiblePrizeFormatter(cell, row) {
  if (row.url) {
    if (row.paidTeams > 0 || row.isFinals) {
      return formatCurrency(row.maxPrize);
    } else {
      return null; 
    }
  }
  return null;
}

const NoDataIndication = () => (
  <div>There are no games available right now, please come back later!</div>
);

function EnterOrFullBtnLabel({row, buttonLabels}) {
  if (row.url) {
    if (row.paidTeams < row.allTeams) {
      if (row.state == 2){
        return <button
            style={{ textTransform: "uppercase" }}
            className="game-btn game-enter"
        >
          {buttonLabels.enter}
        </button>
      }
      return null;
    } else {
      if (row.state == 2) {
        if (row.allTeams > 0) {
          // only if paidTeams == teamsLimit
          if (row.paidTeams == row.allTeams) {
            return <button
              style={{ textTransform: "uppercase" }}
              className="game-btn game-full"
            >
              {buttonLabels.full}
            </button>
          }
          return null;
        }
        return null;
      } 
      return null;
    }
  }
  return null;
}

function GameNameWithIcon({ name, sportsId, row = null, buttonLabels = null, isFull = false }) {
  return (
    <div className="game-name">
      <div className="game-name__item">
        <div className={`game-icon ${isFull && 'full-fade'}`}>
          <i className={cn("z-icon", sportsIconMap[sportsId], (isFull && "text-dark"))} />
        </div>
        <h2 className={`game-name-title ${isFull && 'text-full'}`}>{name}</h2>
      </div>

      {/* Enter/Full button */}
      <div className="game-name__item">
        {row.url && (
          <div className="game-enter-btn-container-outside">
            <EnterOrFullBtnLabel row={row} buttonLabels={buttonLabels} />
          </div>
        )}
      </div>
    </div>
  );
}

function GameDetailColumn({ title, value, containerClass, isFull = false }) {
  return (
    <div className={cn("game-details", containerClass)}>
      <h2 className={`title-head ${isFull ? 'text-full' : ''}`}>{title}</h2>
      <p className={`item-value ${isFull ? 'text-full' : ''}`}>{value}</p>
    </div>
  );
}

function LobbyGameDetails({ isVisible, gameId, onClose }) {
  if (!gameId) return null;
  return (
    <div className="bsWrapped-default">
      <GameDetails
        onClose={onClose}
        trigger={false}
        isVisible={isVisible}
        gameId={gameId}
      />
    </div>
  );
}

const MemoizedGameDetails = React.memo(
  LobbyGameDetails,
  (prevProps, nextProps) => {
    if (
      prevProps.isVisible === nextProps.isVisible &&
      prevProps.gameId === nextProps.gameId
    ) {
      return true;
    }
    return false;
  }
);

function LobbyTable({
  data,
  sort,
  onSort,
  onTableChange,
  loggedIn,
  gameDetailsVisible,
  selectedGameId,
  handleGameDetails,
  user,
  handleShowRestrictionModal
}) {
  const translations = useContext(TranslationsContext);
  const sportsNameCtx = useContext(SportsNameContext);
  
  const hiddenSportsId = [];
  for (let key in sportsNameCtx) {
    if (sportsNameCtx.hasOwnProperty(key)) {
      if (sportsNameCtx[key]['isLobbyActive'] == 0) hiddenSportsId.push(key); 
    }
  }

  let filteredData = data.filter(obj => !hiddenSportsId.includes(obj.sports_id));

  const { sport, game, teams, fee, date, time, prizes, livein, enter, full, maxPrize } =
    translations.messages || {};

  function liveInFormatter(cell, row) {
    if (cell) {
      return <p>{formatLiveInTime(cell)}</p>;
    }
    return null;
  }

  function sortCaret(order, column) {
    if (!order) return <span className="table-carret default" />;
    else if (order === "asc") return <span className="table-carret sort-asc" />;
    else if (order === "desc")
      return <span className="table-carret sort-desc" />;
    return null;
  }

  function mobileRowFormatter(cell, row) {
    // Format maxPrize
    let maxPrizeFormatted = "";
    if (row.url) {
      if (row.paidTeams > 0) {
        maxPrizeFormatted = formatCurrency(row.maxPrize);
      } else {
        maxPrizeFormatted = ""; 
      }
    }

    let isFull = isGameFull(row);
    
    return (
      <div className="tbl-mobile-row game-col-mob">

        {/* Header Icon&Name + Enter/Full Button */}
        <GameNameWithIcon 
          name={row.name} 
          sportsId={row.sports_id} 
          row={row} 
          buttonLabels={ {enter: enter, full: full} } 
          isFull={isFull}
        />


        <div className="game-details-container">
          <div className="game-details-row">
            <div className="game-details-col">
              <GameDetailColumn
                containerClass="first-child"
                title={teams}
                value={
                  row.state == 2 ? `${row.paidTeams}/${row.allTeams}` : null
                }
                isFull={isFull}
              />
              <GameDetailColumn
                containerClass="game-prize-head"
                title={prizes}
                value={
                  row.prizeFinal &&
                  row.prizeFinal.amount &&
                  row.prizeFinal.amount > 0
                    ? formatCurrency(row.prizeFinal)
                    : row.prize
                    ? formatCurrency(row.prize)
                    : null
                }
                isFull={isFull}
              />
            </div>
            <div className="game-details-col">
              <GameDetailColumn
                containerClass="first-child"
                title={fee}
                value={row.price ? formatCurrency(row.price) : null}
                isFull={isFull}
              />
              <GameDetailColumn
                title={livein}
                value={row.startsIn ? formatLiveInTime(row.startsIn) : null}
                isFull={isFull}
              />
            </div>
            <div className="game-details-col">
              <GameDetailColumn
                containerClass="first-child"
                title={date}
                value={row.startsOnDate}
                isFull={isFull}
              />
              <GameDetailColumn title={time} value={row.startsOnTime} isFull={isFull}/>
            </div>
            <div className="game-details-col">
              <GameDetailColumn
                containerClass="first-child"
                title={maxPrize}
                value={maxPrizeFormatted}
                isFull={isFull}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  async function handleRowClick(row) {
    if (!loggedIn) {
      if (row && row.gameId && row.gameId > 0) {
        let isGameDetailsVisible = row.state == 1 ? false : true;
        let selectedGameId = isGameDetailsVisible ? row.gameId : null;
        handleGameDetails({
          selectedGameId,
          isGameDetailsVisible,
        });
      }
    } else {
      // Pre-check
      try {
        let {data, status} = await axios.get(`/api/v1/restricted/${user.userId}/game/${row.gameId}`);
        if (status == 200) {
          // Show restriction modal
          if (data === true) {
            handleShowRestrictionModal(true);
            return;
          } 
          
          // Continue with usual flow
          else {
            if (row.url) {
              if (row.state == 2){
                if (row.paidTeams < row.allTeams) {
                  window.location.href = `${row.url}editTeams`;
                }
              }
            }
          }
        }
      } catch (e) {
        console.log(e);      
      }
    }
  }

  function closeGameDetails() {
    handleGameDetails({ selectedGameId: null, isGameDetailsVisible: false });
  }

  const columns = [
    // startsIn
    {
      dataField: "startsIn",
      isDummyField: true,
      text: "",
      classes: "col-mobile",
      headerClasses: "col-mobile-head",
      formatter: mobileRowFormatter,
    },
    {
      dataField: "sports_id",
      text: sport,
      headerClasses: "col-desktop-head",
      classes: "col-desktop col-sports-icon",
      headerStyle: {
        width: "80px",
      },
      formatter: sportsIconFormatter,
    },
    {
      dataField: "name",
      text: game,
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      headerStyle: {
        width: "345px",
      },
    },
    {
      dataField: "paidTeams",
      text: teams,
      formatter: teamsFormatter,
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      headerStyle: {
        width: "80px",
      },
    },
    {
      dataField: "price",
      text: fee,
      formatter: priceFormatter,
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      headerStyle: {
        width: "75px",
      },
    },
    {
      dataField: "startsOnDate",
      text: date,
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      headerStyle: {
        width: "125px",
      },
    },
    {
      dataField: "startsOnTime",
      text: time,
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      headerStyle: {
        width: "75px",
      },
    }, 
    {
      dataField: "prize",
      text: prizes,
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      formatter: prizeFormatter,
      headerStyle: {
        width: "105px",
      },
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "maxPrize",
      text: "Max Prize",
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      formatter: maxPossiblePrizeFormatter,
      headerStyle: {
        width: "105px",
      },
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "startsIn",
      text: livein,
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      formatter: liveInFormatter,
      headerStyle: {
        width: "100px",
      },
    },
    {
      dataField: "enter",
      text: "",
      headerClasses: "col-desktop-head",
      classes: "col-desktop",
      formatter: (cell, row) => enterFormatter(cell, row, { enter: enter, full: full }),
      headerStyle: {
        width: "100px",
      },
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      handleRowClick(row);
    },
  };

  const rowClasses = (row, rowIndex) => {
    let classes = null;

    // if (row.url) {
    //   if (row.paidTeams < row.allTeams) {
    //     classes = "active-hover";
    //   } else {
    //     classes = "row-full";
    //   }
    // }

    if (isGameFull(row)) {
      classes = "row-full";
    } else {
      classes = "active-hover";
    }

    return classes;
  };

  return (
    <>
      <MemoizedGameDetails
        onClose={closeGameDetails}
        gameId={selectedGameId}
        isVisible={gameDetailsVisible}
      />
      <div className="bs4-wrapper lobby-table-container">
        <BootstrapTable
          striped
          remote={{ sort: true }}
          keyField="upcomingGameId"
          data={filteredData}
          columns={columns}
          wrapperClasses="table-responsive"
          rowEvents={rowEvents}
          rowClasses={rowClasses}
          noDataIndication={() => <NoDataIndication />}
          onTableChange={onTableChange}
        />
      </div>
    </>
  );
}

function LobbyTicker({
  index,
  title,
  className,
  prizePool,
  amount,
  image,
  href,
}) {
  return (
    <a
      href={href}
      style={{
        backgroundImage: `url(${image})`,
      }}
      className={cn("lobby-ticker", className)}
    >
      <h2>{title}</h2>
      <h3>
        {prizePool && prizePool.length > 0 ? `${prizePool} ` : null}
        <span>{amount}</span>
      </h3>
      <span className={cn("gradient", bannersGradientMap[index])} />
    </a>
  );
}

function LobbyTickers({ banners, className }) {
  if (!banners || banners.length === 0) return null;
  return (
    <div className={`lobby-tickers${className ? ` ${className}` : ""}`}>
      {banners.map((banner, i) => (
        <LobbyTicker
          index={i}
          key={banner.id}
          prizePool={banner.regularText}
          title={banner.headerText}
          amount={banner.moneyText}
          image={banner.imageUrl}
          href={banner.linkUrl}
        />
      ))}
    </div>
  );
}

function AccountBalance({ amount }) {
  const translations = useContext(TranslationsContext);
  return (
    <div className="acc-blc-cnt">
      <h3 className="title">{`${translations.messages.balance}:`}</h3>
      <h3 className="amount">{`${amount}`}</h3>
    </div>
  );
}

function AccountBonus({ amount }) {
  const translations = useContext(TranslationsContext);
  return (
    <div className="acc-bonus-cnt">
      <h3 className="title">{`${translations.messages.bonus}:`}</h3>
      <h3 className="amount">{`${amount}`}</h3>
    </div>
  );
}

function DepositBalance({ onClick }) {
  const translations = useContext(TranslationsContext);
  return (
    <button
      style={{ textTransform: "uppercase" }}
      onClick={onClick}
      className="btn-deposit-balance"
    >
      {translations.messages.deposit}
    </button>
  );
}

function AccountStatistics({ balance, bonus }) {
  const handleDepositClick = () => {
    window.location.href = "/main/deposit";
  };
  return (
    <div className="account-statistics">
      <div className="acc-sts-cnt">
        <div className="acc-sts-cnt-inner">
          <AccountBalance
            amount={formatCurrency({
              amount: balance.amount,
              currency: balance.currencyCode,
            })}
          />
          <AccountBonus
            amount={formatCurrency({
              amount: bonus.amount,
              currency: bonus.currencyCode,
            })}
          />
        </div>
        <DepositBalance onClick={handleDepositClick} />
      </div>
    </div>
  );
}

function SportsIcon({
  containerClass,
  iconStylesClass,
  iconClass,
  onClick,
  sportsId,
  activeFilterId,
  title,
  id = "",
  isFull = false,
}) {
  const ctx = useContext(SportsNameContext);

  const iconWhite = isFull ? 'icon-white' : ''

  if (id) {
    if (ctx[id]['isLobbyActive'] == 1) {
      return (
        <div className={containerClass}>
          <i
            style={{
              color: parseInt(sportsId) === activeFilterId ? "#d7581b" : null,
            }}
            onClick={() => onClick(parseInt(sportsId))}
            className={cn("z-icon", iconStylesClass, iconClass, iconWhite)}
            title={ctx[id]["name"] || title}
          />
        </div>
      );
    }
  }

  return (<></>);
}

function LobbyFilters({ onClick, activeFilterId, filters }) {
  return (
    <div className="lobby-filters">
      {filters.length > 0
        ? filters.map((filter) => (
            <SportsIcon
              key={`s-filter-${filter}`}
              activeFilterId={activeFilterId}
              sportsId={filter}
              onClick={onClick}
              iconStylesClass="sports-icon abs-pos"
              iconClass={sportsIconMap[filter]}
              title={sportsNameMap[filter]}
              containerClass="sports-icon-container"
              id={filter}
            />
          ))
        : null}
    </div>
  );
}

function LobbyHeader({ user, filters, onFilterClick, activeFilterId }) {
  return (
    <div className="lobby-content-header">
      <LobbyFilters
        filters={filters}
        onClick={onFilterClick}
        activeFilterId={activeFilterId}
      />
      {user && user.loggedIn && (
        <AccountStatistics balance={user.balance} bonus={user.bonus} />
      )}
    </div>
  );
}

function SportSelectMobile({ onClick, activeFilterId, filters }) {
  const translations = useContext(TranslationsContext);
  const ctx = useContext(SportsNameContext);

  return (
    <div className="mobile-select-container">
      <div className="mobile-select">
        <DropdownWrapper
          closeOnEsc
          wrapperProps={{
            className: "dropdown-wrapper",
          }}
        >
          {({ changeStatus, isShow }) => (
            <>
              <button
                className="dropdown-toggle"
                onClick={() => changeStatus(!isShow)}
              >
                {activeFilterId ? (
                  <span className="drowndown-icon-container">
                    <i
                      className={cn(
                        "z-icon",
                        "dropdown-sports-icon",
                        sportsIconMap[activeFilterId]
                      )}
                    />
                  </span>
                ) : null}

                {activeFilterId
                  ? ctx[activeFilterId]["name"] || sportsNameMap[activeFilterId]
                  : translations.messages["choose-sport"]}
              </button>
              {isShow && filters && filters.length > 0 && (
                <div className="dropdown">
                  <div
                    onClick={() => {
                      onClick("showall");
                      changeStatus(!isShow);
                    }}
                    className="dropdown-item"
                  >
                    {`${translations.messages["show-all"]}`}
                  </div>
                  {filters.map((filter) => (
                    <div
                      onClick={() => {
                        onClick(parseInt(filter));
                        changeStatus(!isShow);
                      }}
                      key={filter}
                      className="dropdown-item"
                    >
                      {ctx[filter]["name"] || sportsNameMap[filter]}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </DropdownWrapper>
      </div>
    </div>
  );
}

const MemoSportSelectMobile = React.memo(SportSelectMobile);

function ContestType() {
  const translations = useContext(TranslationsContext);
  return (
    <div className="mobile-select-container" style={{ marginLeft: "1px" }}>
      <h3 className="select-label">{`${translations.messages["choose-contest-type"]}:`}</h3>
      <div className="mobile-select">
        <DropdownWrapper
          closeOnEsc
          wrapperProps={{
            className: "dropdown-wrapper",
          }}
        >
          {({ changeStatus, isShow }) => (
            <>
              <button
                className="dropdown-toggle"
                onClick={() => changeStatus(!isShow)}
              >
                {translations.messages.featured}
              </button>
              {isShow && (
                <div className="dropdown">
                  <div
                    onClick={() => {
                      changeStatus(!isShow);
                    }}
                    className="dropdown-item"
                  >
                    {translations.messages.featured}
                  </div>
                </div>
              )}
            </>
          )}
        </DropdownWrapper>
      </div>
    </div>
  );
}

const MemoContestType = React.memo(ContestType);

function SortBy({ sortBy, sortOrder, onTableSort }) {
  const translations = useContext(TranslationsContext);

  function handleSort(field, order, cb) {
    onTableSort(field, order);
    cb(false);
  }
  return (
    <div className="sort-by-mobile-container">
      <div className="mobile-select">
        <DropdownWrapper
          closeOnEsc
          wrapperProps={{
            className: "dropdown-wrapper",
          }}
        >
          {({ changeStatus, isShow }) => (
            <>
              <button
                className="dropdown-toggle sort-by-toggle"
                onClick={() => changeStatus(!isShow)}
              >
                {sortOrder === null && translations.messages["sort-by"]}
                {sortOrder === "asc" && translations.messages["prize-low-high"]}
                {sortOrder === "desc" &&
                  translations.messages["prize-high-low"]}
              </button>

              {isShow && (
                <div className="dropdown">
                  <div
                    onClick={() => {
                      handleSort(null, null, changeStatus);
                    }}
                    className="dropdown-item"
                  >
                    {`${translations.messages["show-all"]}`}
                  </div>
                  <div
                    onClick={() => {
                      handleSort("prize", "desc", changeStatus);
                    }}
                    className="dropdown-item"
                  >
                    {`${translations.messages["prize-high-low"]}`}
                  </div>
                  <div
                    onClick={() => {
                      handleSort("prize", "asc", changeStatus);
                    }}
                    className="dropdown-item"
                  >
                    {`${translations.messages["prize-low-high"]}`}
                  </div>
                </div>
              )}
            </>
          )}
        </DropdownWrapper>
      </div>
    </div>
  );
}

const MemoSortBy = React.memo(SortBy);

function compareValues(key, order = "asc") {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}

class LobbyContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allGames: [],
      gamesToShow: [],
      liveSports: [],
      banners: [],
      gamesPerPage: 20,
      filterBySportsId: null,
      filteredSports: [],
      sort: {
        dataField: null,
        order: null,
      },
      loading: true,
      isGameDetailsVisible: false,
      selectedGameId: null,
      sportsNameMap,
      showRestrictionModal: false,
    };
    this.timer = null;
  }

  handleSort = (dataField, order) => {
    this.setState({ sort: { dataField, order } });
  };

  componentDidMount() {
    fetchAllGames({ currency: this.props.user.currency || "EUR" }).then(
      ({ data }) => {
        const liveSports = {};
        data.games.forEach((game) => {
          if (game.sportId) {
            liveSports[game.sportId] = (liveSports[game.sportId] || 0) + 1;
          }
        });
        const updatedTime = Math.floor(new Date().getTime() / 1000);
        const allGames = data.games.map((game) => {
          if (game.startsIn) {
            game.startsIn = game.startsIn - updatedTime;
            return game;
          }
          return game;
        });
        const gamesToShow = allGames.slice(0, this.state.gamesPerPage);
        let sportsNameMap = this.state.sportsNameMap;
        if (data.sports) {
          sportsNameMap = data.sports;
        }
        this.setState(
          {
            allGames,
            gamesToShow,
            liveSports: Object.keys(liveSports),
            loading: false,
            sportsNameMap,
          },
          this.updateGameLiveIn
        );
      }
    );

    fetchBanners({
      currency: this.props.user.currency || "EUR",
      language: this.props.user.language || "en",
    }).then(({ data }) => {
      this.setState({ banners: data });
    });

    const qd = {};
    try {
      if (window.location.search) {
        window.location.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
            qd[item.split("=")[0]] = item.split("=")[1];
          });
      }
    } catch (e) {
      console.log(e);
    }

    if (
      qd &&
      qd.redirect &&
      qd.redirect.toUpperCase() === "TRUE" &&
      qd.gameId &&
      !isNaN(parseInt(qd.gameId))
    ) {
      this.setState({
        isGameDetailsVisible: true,
        selectedGameId: parseInt(qd.gameId),
      });
    }
  }

  updateGameLiveIn = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => {
      this.setState((prevState) => ({
        gamesToShow: prevState.gamesToShow.map((game) => {
          if (game.startsIn) {
            game.startsIn = --game.startsIn;
            return game;
          }
          return game;
        }),
      }));
    }, 1000);
  };

  loadMoreGames = () => {
    const {
      gamesPerPage,
      allGames,
      filteredSports,
      filterBySportsId,
    } = this.state;
    if (filterBySportsId) {
      const gamesToShow = filteredSports.slice(0, gamesPerPage + 20);
      this.setState(
        { gamesToShow, gamesPerPage: gamesPerPage + 20 },
        this.updateGameLiveIn
      );
    } else {
      const gamesToShow = allGames.slice(0, gamesPerPage + 20);
      this.setState(
        { gamesToShow, gamesPerPage: gamesPerPage + 20 },
        this.updateGameLiveIn
      );
    }
  };

  handleFilterClick = (sportsId) => {
    if (sportsId === this.state.filterBySportsId || sportsId === "showall") {
      const gamesToShow = this.state.allGames.slice(0, 20);
      this.setState(
        {
          gamesToShow,
          gamesPerPage: 20,
          filterBySportsId: null,
          filteredSports: [],
        },
        this.updateGameLiveIn
      );
    } else {
      const filteredSports = this.state.allGames.filter(
        (sport) => sport.sportId === sportsId
      );
      const gamesToShow = filteredSports.slice(0, 20);
      this.setState(
        {
          gamesToShow,
          gamesPerPage: 20,
          filteredSports,
          filterBySportsId: sportsId,
        },
        this.updateGameLiveIn
      );
    }
  };

  renderLoadMoreButton = () => {
    const button = (
      <div onClick={this.loadMoreGames} className="load-more">
        {this.props.translations.messages["loadmore"] || "Load More"}
      </div>
    );
    if (this.state.filterBySportsId) {
      if (this.state.filteredSports.length !== this.state.gamesToShow.length) {
        return button;
      }
      return null;
    } else {
      if (this.state.allGames.length !== this.state.gamesToShow.length) {
        return button;
      }
      return null;
    }
  };

  handleLoginBtnClick = () => {
    const loginFormContainer = document.getElementById("loginFormContainer");
    if (!loginFormContainer) return;
    if (loginFormContainer.classList.contains("form-visible")) {
      loginFormContainer.classList.remove("form-visible");
    } else {
      loginFormContainer.classList.add("form-visible");
    }
  };

  sortTable = (sortField, sortOrder) => {
    const sort = { dataField: sortField, order: sortOrder };
    // Sort all games
    const { allGames, filterBySportsId, gamesPerPage } = this.state;
    const allGamesSorted = [...allGames];
    allGamesSorted.sort((a, b) => {
      if (a[sortField] === null) return 1;
      if (b[sortField] === null) return -1;

      if (sortOrder === "asc") {
        return a[sortField].amount - b[sortField].amount;
      }

      if (sortOrder === "desc") {
        return b[sortField].amount - a[sortField].amount;
      }
    });

    // If Games are filtered by sports id take the filtered sports otherwise slice the games to show
    if (filterBySportsId) {
      const filteredSports = this.state.allGames.filter(
        (sport) => sport.sportId === filterBySportsId
      );
      const gamesToShow = filteredSports.slice(0, gamesPerPage);
      this.setState(
        { gamesToShow, filteredSports, allGames: allGamesSorted, sort },
        this.updateGameLiveIn
      );
    } else {
      const gamesToShow = allGamesSorted.slice(0, gamesPerPage);
      this.setState(
        { gamesToShow, allGames: allGamesSorted, sort },
        this.updateGameLiveIn
      );
    }
  };

  handleManualSort = (dataField, order) => {
    this.sortTable(dataField, order);
  };

  handleTableChange = (type, { sortField, sortOrder }) => {
    this.sortTable(sortField, sortOrder);
  };

  handleGameDetails = ({ selectedGameId, isGameDetailsVisible }) => {
    this.setState({ isGameDetailsVisible, selectedGameId });
  };

  handleShowRestrictionModal = (show) => {
    this.setState({showRestrictionModal: show});
  }

  render() {
    const { gamesToShow, filterBySportsId, loading } = this.state;
    const { translations } = this.props;
    if (loading) {
      return (
        <div
          className="lobby-container"
          style={{
            height: "1166px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      );
    }
    return (
      <TranslationsContext.Provider value={this.props.translations}>
        <SportsNameContext.Provider value={this.state.sportsNameMap}>
          <div className="lobby-container">
            <div className="lobby-content-container">
              <LobbyTickers
                className="tickers-mobile"
                banners={this.state.banners.slice(0, 2)}
              />
              {!this.props.user.loggedIn && (
                <div className="mobile-account-links">
                  <a href onClick={this.handleLoginBtnClick}>
                    {`${translations.messages.login} +`}
                  </a>
                  <a href="/main/register">{`${translations.messages.register} +`}</a>
                </div>
              )}

              <LobbyHeader
                filters={this.state.liveSports}
                activeFilterId={filterBySportsId}
                user={this.props.user}
                onFilterClick={this.handleFilterClick}
              />
              <LobbyTickers banners={this.state.banners} />
              <div className="lobby-mobile-filters">
                <div className="mobile-filters-container clearfix">
                  <MemoSportSelectMobile
                    filters={this.state.liveSports}
                    onClick={this.handleFilterClick}
                    activeFilterId={filterBySportsId}
                  />
                  {/* <MemoContestType /> */}
                  <MemoSortBy
                    sortBy={this.state.sort.dataField}
                    sortOrder={this.state.sort.order}
                    onTableSort={this.handleManualSort}
                  />
                  <button
                    onClick={() => (window.location.href = "/results")}
                    className="btn-orange btn-lobby-mobile-results"
                  >{`${translations.messages.results}`}</button>
                </div>
              </div>
              <LobbyTable
                sort={this.state.sort}
                onSort={this.handleSort}
                data={gamesToShow}
                onTableChange={this.handleTableChange}
                loggedIn={this.props.user.loggedIn}
                gameDetailsVisible={this.state.isGameDetailsVisible}
                selectedGameId={this.state.selectedGameId}
                handleGameDetails={this.handleGameDetails}
                user={this.props.user}
                handleShowRestrictionModal={this.handleShowRestrictionModal}
              />
              {this.renderLoadMoreButton()}
            </div>

            <Modal show={this.state.showRestrictionModal}>
              <div className="game-detail-modal" style={{ maxWidth: '800px' }}>
                <a
                  className="close-modal"
                  onClick={() => this.handleShowRestrictionModal(false)}
                  aria-label="Close"
                >
                  Close
                </a>
                
                <div className="game-detail-head">
                  <div style={{ marginTop: '3rem' }}>
                    <p style={{ fontWeight: '700' }}>
                    Het is op dit moment niet mogelijk om teams te maken bij Zweeler Fantasy Sports Games als je uit Nederland komt. We hopen dat dit in de toekomst wel weer mogelijk is. Excuses voor het ongemak.
                    </p>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </SportsNameContext.Provider>
      </TranslationsContext.Provider>
    );
  }
}

const mapStateToProps = ({ user, translations }) => ({
  user,
  translations,
});

export default connect(mapStateToProps, {})(LobbyContainer);
